module.exports = __webpack_public_path__ + "img/7ab78c0.svg";